module.exports = __webpack_public_path__ + "static/media/h-rank.980408b1.png";